export default __webpack_public_path__ + "static/media/SPECTRA-RETRACTABLE ROOF-BENGALURU.0a83f126.jpg";